import {callApi} from "./Api";
import { actionCreator } from './helpers'

export const GET_CLIENT_SUBSCRIPTION_STATS = 'GET_CLIENT_SUBSCRIPTION_STATS'
export const GET_CLIENT_STATS = 'GET_CLIENT_STATS'
export const GET_CLIENT_TAG_STATS = 'GET_CLIENT_TAG_STATS'
export const GET_INSIGHTS_PERIOD_STATS = 'GET_INSIGHTS_PERIOD_STATS'
export const CLEAR_DASHBOARD_STATS = 'CLEAR_DASHBOARD_STATS'

export const clearDashboardStats = actionCreator(CLEAR_DASHBOARD_STATS)

export const getClientSubscriptionStats = () => {
	return (dispatch, getState) => {
		callApi(dispatch, getState, GET_CLIENT_SUBSCRIPTION_STATS, 'clients/subscription/stats')
	}
}

export const getClientStats = () => {
	return (dispatch, getState) => {
		callApi(dispatch, getState, GET_CLIENT_STATS, 'clients/stats')
	}
}

export const getClientTagStats = () => {
	return (dispatch, getState) => {
		callApi(dispatch, getState, GET_CLIENT_TAG_STATS, 'clients/tag/stats')
	}
}

export const getInsightsStats = (period) => {
	const url = `insights/${period}/stats`
	return (dispatch, getState) => {
		callApi(dispatch, getState, GET_INSIGHTS_PERIOD_STATS, url)
	}
}


// WEBPACK FOOTER //
// ./src/actions/Dashboard.js